module.exports = __webpack_public_path__ + "img/Dantam Bridal 28.f3a05ac1.jpg";